import React, { useEffect, useState } from 'react';
import {
  extend,
  params,
  shape,
  string as stringType,
  number as numberType,
} from '@thd-nucleus/data-sources';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { useLoyaltyMembershipDetails } from '../../../hooks/useDataSources';
import { useExperienceContext } from '../../../hooks/useContexts';

export const PTCInfoBanner = () => {
  const { isConsumerApp } = useExperienceContext();
  const { data, loading } = useLoyaltyMembershipDetails() ?? {};
  const [showAlert, setShowAlert] = useState(false);

  /* Checks the proTiers.benefitTags to determine if the account is a Pro Trade account, 
  where a tag's tagName includes 'ProTradeCredit' and tag.value is 'TCConfirmed' */
  const checkIfProHouseAccount = (proTiers: {
    benefitTags: { tagName: string; value: string; __typename: string }[];
  }): boolean => {
    if (proTiers === undefined) return false;
    return proTiers?.benefitTags.some(
      (tag) =>
        tag.tagName.includes('ProTradeCredit') && tag.value === 'TCConfirmed',
    );
  };

  useEffect(() => {
    if (!loading && data) {
      const isProHouseAccount = checkIfProHouseAccount(
        data?.loyaltyMembershipDetails?.proTiers,
      );
      if (isProHouseAccount) setShowAlert(true);
    }
  }, [data?.loyaltyMembershipDetails?.proTiers]);

  if (!showAlert || isConsumerApp) return null;
  return (
    <Alert
      status="info"
      size="large"
      onClose={() => {
        setShowAlert(false);
      }}
    >
      <Typography variant="body-sm">
        You can now view your Pro Trade Credit Invoices in Order Details!
      </Typography>
    </Alert>
  );
};

const proTiers = shape({
  benefitTags: shape({
    tagName: stringType(),
    value: stringType(),
  }),
});

PTCInfoBanner.dataModel = extend({
  loyaltyMembershipDetails: params({
    channelId: numberType().isRequired(),
    customerAccountId: stringType().isRequired(),
    userId: stringType().isRequired(),
  }).shape({
    proTiers,
  }),
});
